import { render, staticRenderFns } from "./BusinessIntelligence.vue?vue&type=template&id=e133377c&scoped=true"
import script from "./BusinessIntelligence.vue?vue&type=script&lang=js"
export * from "./BusinessIntelligence.vue?vue&type=script&lang=js"
import style0 from "./BusinessIntelligence.vue?vue&type=style&index=0&id=e133377c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e133377c",
  null
  
)

export default component.exports